import { Paragraph } from '../Typography';
import Image from 'next/image';

interface INoResultFoundProps {
  height: string;
  width: string;
  texts: string[];
}
export const NoResultFound = ({
  height,
  width,
  texts,
}: INoResultFoundProps): JSX.Element => (
  <>
    <div className="flex justify-center mt-20">
      <Image
        src="https://assets1.cleartax-cdn.com/cleartax/images/1649544114_group18142086.png"
        height={height}
        width={width}
        alt="No Result Found"
      ></Image>
    </div>
    <div className="text-center mt-10">
      {typeof texts !== 'undefined'
        ? texts.map((text: string) => <Paragraph key={text}>{text}</Paragraph>)
        : null}
    </div>
  </>
);
